import React, { FC } from 'react'
import { P } from 'components/base/typography/misc'
import { Flex } from 'rebass'
import Button from 'components/base/buttons/buttons'
import styled from 'styled-components'

const ProcessText = styled(P)`
	width: 100%;
	text-align: center;
`

interface Props {
	products: number
	totalProducts: number
	page: number
	pageSize: number
	loading: boolean
	nextPagePath: string
	handleLoadMore: () => void
}

const LoadNext: FC<Props> = ({ products, totalProducts, page, pageSize, loading, nextPagePath, handleLoadMore }) => {
	const isLastPage = page * pageSize >= totalProducts

	const handleClick = (event: React.MouseEvent) => {
		event.preventDefault()
		handleLoadMore()
	}

	return (
		<Flex justifyContent="center" flexWrap="wrap" mt="6rem">
			{products > 0 && (
				<ProcessText>
					Þú hefur skoðað {isLastPage ? totalProducts : page * pageSize} af {totalProducts} vörum
				</ProcessText>
			)}
			{!isLastPage && (
				<a href={nextPagePath} onClick={handleClick}>
					<Button isLoading={loading} primary clipText noFill mt="2rem">
						Sjá fleiri vörur
					</Button>
				</a>
			)}
		</Flex>
	)
}

export default LoadNext
